import { useIntl } from 'react-intl';
import { FlatIconButton, InlineNotification, Typography } from '@packages/shared';
import { InformationCircle32 } from '@packages/themes/icons';
import React from 'react';
import { useInstallmentCalculatorTracking } from '../../components/Tracking/hooks/useInstallmentCalculatorTracking';
import { infoCallToActionMessages } from './messages';

/**
 * info call to action atom
 *
 * atom to display information about the installment process
 *
 * */
export const InfoCallToAction = () => {
  const { formatMessage } = useIntl();
  const [showNotification, setShowNotification] = React.useState(false);

  const { trackGlycerinImageClick } = useInstallmentCalculatorTracking();

  const handleClick = () => {
    setShowNotification(true);
    trackGlycerinImageClick();
  };

  const handleClose = () => {
    setShowNotification(false);
  };

  return showNotification ? (
    <InlineNotification severity="info" onClose={handleClose}>
      {formatMessage(infoCallToActionMessages.Infotext, {
        intro: (chunks: React.ReactNode) => (
          <Typography fontWeight="bold" mb={1}>
            {chunks}
          </Typography>
        ),
        item: (chunks: React.ReactNode) => (
          <Typography variant="body3" component="p" mb={1}>
            {chunks}
          </Typography>
        ),
      })}
    </InlineNotification>
  ) : (
    <FlatIconButton sx={{ width: '1.5rem', height: '1.5rem' }} onClick={handleClick}>
      <InformationCircle32
        sx={{ fill: (theme) => theme.palette.info.main, width: '1.25rem', height: '1.25rem' }}
      />
    </FlatIconButton>
  );
};
